module.exports = __webpack_public_path__ + "static/ibironke-65ce9771dc536344cdd320d34982eeb8.png";